import React from 'react'
import Typewriter from 'typewriter-effect'
import Image from 'next/image'

const textSmallBaseStyle =
  'font-swinton font-normal text-[15px] leading-none tracking-[-0.05em] text-right align-bottom'

const titleClasses = 'whitespace-pre-line font-abcd font-extrabold text-[25px] leading-[0.8em] tracking-normal uppercase'
const descriptionClasses = 'font-swinton font-normal text-[16px] leading-none tracking-[-0.05em] text-left'

const Phone = (props: any) => (
  <div className='pt-[105px]'>
    <div className='flex flex-col items-center mb-[100px] pb-0'>
      <div className='flex flex-col items-center w-full'>
        <div className='w-full small-texts w-full bg-white'>
          <div className='flex justify-center'>
            <div className='w-1/3 flex justify-center items-center'>
              <div className={textSmallBaseStyle}>{props.headerTextLeft}</div>
            </div>
            <div className='w-1/3 flex justify-center items-center'>
              <div className={textSmallBaseStyle}>{props.headerTextCenter}</div>
            </div>
            <div className='w-1/3 flex justify-center items-center'>
              <div className={textSmallBaseStyle}>{props.headerTextRight}</div>
            </div>
          </div>
        </div>
        <div
          className={`-mt-[3px] w-5/6 text-center uppercase font-abcd font-extrabold text-[50px] tracking-[-0.05em] leading-[78%]`}
        >
          <Typewriter
            onInit={(typewriter) => {
              typewriter.typeString(props.headerLargeText).start()
            }}
          />
        </div>
      </div>
    </div>
    <div className='flex flex-col items-baseline w-full font-sans text-[#1E1E1E]'>
      <div className='flex flex-col items-baseline w-full gap-16 mb-[50px]'>
        <div className='flex flex-col items-baseline px-2'>
          <h2 className='font-abcd font-extrabold text-[25px] leading-[0.8em] tracking-normal uppercase mb-1'>
            {props.awardCategoryMainText}
          </h2>
          <p className='font-swinton font-normal text-[16px] leading-none tracking-[-0.05em] text-left max-w-xl mb-[50px]'>
            {props.awardCategorySubText}
          </p>
          <div className='flex flex-col w-full max-w-xl gap-12 text-left'>
            <div className='flex-1 min-w-0'>
              <h3 className='font-abcd font-extrabold text-[25px] leading-[0.8em] tracking-normal uppercase mb-1'>
                {props.awardCategory1}
              </h3>
              <p className={descriptionClasses}>
                {props.awardCategory1Brief}
              </p>
            </div>
            <div className='flex-1 min-w-0'>
              <h3 className='font-abcd font-extrabold text-[25px] leading-[0.8em] tracking-normal uppercase mb-1'>
                {props.awardCategory2}
              </h3>
              <p className={descriptionClasses}>
                {props.awardCategory2Brief}
              </p>
            </div>
            <div className='flex-1 min-w-0 mb-[36px]'>
              <h3 className='font-abcd font-extrabold text-[25px] leading-[0.8em] tracking-normal uppercase mb-1'>
                {props.awardCategory3}
              </h3>
              <p className={descriptionClasses}>
                {props.awardCategory3Brief}
              </p>
            </div>
          </div>
          <div className='flex flex-col w-full gap-9 text-left'>
            <div className='flex-1 min-w-0'>
              <h3 className={titleClasses}>
                {props.awardCategory4}
              </h3>
              <p className={descriptionClasses}>
                {props.awardCategory4Brief}
              </p>
            </div>
            <div className='flex-1 min-w-0'>
              <h3 className={titleClasses}>
                {props.awardCategory5}
              </h3>
              <p className={descriptionClasses}>
                {props.awardCategory5Brief}
              </p>
            </div>
            <div className='flex-1 min-w-0 mb-[36px]'>
              <h3 className={titleClasses}>
                {props.awardCategory6}
              </h3>
              <p className={descriptionClasses}>
                {props.awardCategory6Brief}
              </p>
            </div>
          </div>
          <div className='flex flex-col w-full gap-9 text-left'>
            <div className='flex-1 min-w-0'>
              <h3 className={titleClasses}>{props.awardCategory7}</h3>
              <p className={descriptionClasses}>
                {props.awardCategory7Brief}
              </p>
            </div>
            <div className='flex-1 min-w-0'>
              <h3 className={titleClasses}>{props.awardCategory8}</h3>
              <p className={descriptionClasses}>
                {props.awardCategory8Brief}
              </p>
            </div>
            <div className='flex-1 min-w-0'>
              <h3 className={titleClasses}>{props.awardCategory9}</h3>
              <p className={descriptionClasses}>
                {props.awardCategory9Brief}
              </p>
            </div>
          </div>
        </div>
      </div>
      <React.Fragment key={1}>
        {props.image1?.data?.attributes?.url &&
          <div className='w-full aspect-[726/395] relative mb-[50px]'>
            <Image
              src={`https://dza2a2ql7zktf.cloudfront.net/binaries-cdn/dqzqcuqf9/image/fetch/f_auto/${props.image1?.data?.attributes?.url}`}
              alt={props.awardRecognitionMainText}
              fill
              style={{ objectFit: 'cover' }}
            />
          </div>
        }
        <div className='flex flex-col items-baseline w-full px-2'>
          <div className='flex flex-col items-baseline w-full mb-[35px]'>
            <h3 className={titleClasses}>
              {props.awardRecognitionMainText}
            </h3>
            <p className={descriptionClasses}>
              {props.awardRecognitionSubText}
            </p>
          </div>
        </div>
      </React.Fragment>

      <React.Fragment key={2}>
        {props.image2?.data?.attributes?.url &&
          <div className='w-full aspect-[726/395] relative mb-[50px]'>
            <Image
              src={`https://dza2a2ql7zktf.cloudfront.net/binaries-cdn/dqzqcuqf9/image/fetch/f_auto/${props.image2?.data?.attributes?.url}`}
              alt={props.keyDatesMainText}
              fill
              style={{ objectFit: 'cover' }}
            />
          </div>
        }
        <div className='flex flex-col items-baseline w-full gap-16 px-2'>
          <div className='flex flex-col items-baseline w-full mb-[50px]'>
            <h3 className={`${titleClasses} mb-[30px]`}>
              {props.keyDatesMainText}
            </h3>
            <div className='w-full'>
              <div className='flex flex-row w-full justify-between items-start gap-6'>
                <div className='text-left'>
                  <p className='font-abcd font-extrabold text-[16px] leading-[0.9em] tracking-normal uppercase'>
                    {props.awardEvent1}
                    <br />
                    {props.awardEvent2}
                    <br />
                    {props.awardEvent3}
                  </p>
                </div>
                <div className='text-right'>
                  <p className='font-abcd font-extrabold text-[16px] leading-[0.9em] tracking-normal uppercase'>
                    {props.awardEvent1Date}
                    <br />
                    {props.awardEvent2Date}
                    <br />
                    {props.awardEvent3Date}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>

      <React.Fragment key={3}>
        {props.image3?.data?.attributes?.url &&
          <div className='w-full aspect-[726/395] relative mb-[50px]'>
            <Image
              src={`https://dza2a2ql7zktf.cloudfront.net/binaries-cdn/dqzqcuqf9/image/fetch/f_auto/${props.image3?.data?.attributes?.url}`}
              alt={props.judgingProcessHeading}
              fill
              style={{ objectFit: 'cover' }}
            />
          </div>
        }
        <div className='flex flex-col items-baseline w-full gap-16 px-2'>
          <div className='flex flex-col items-baseline w-full mb-[50px]'>
            <h3 className={titleClasses}>{props.judgingProcessHeading}</h3>
            <div className='w-full mt-[30px]'>
              <div className='flex flex-col w-full text-left gap-8'>
                <div key='jp-stage1' className='flex-1 min-w-0'>
                  <h3 className={titleClasses}>
                    {props.stageOneHeading}
                  </h3>
                  <p className={descriptionClasses}>
                    {props.stageOneSubHeading}
                  </p>
                </div>
                <div key='291:1189' className='flex-1 min-w-0'>
                  <h3 className={titleClasses}>
                    {props.stageTwoHeading}
                  </h3>
                  <p className={descriptionClasses}>
                    {props.stageTwoSubHeading}
                  </p>
                </div>
                <div key='291:1191' className='flex-1 min-w-0'>
                  <h3 className={titleClasses}>
                    {props.stageThreeHeading}
                  </h3>
                  <p className={descriptionClasses}>
                    {props.stageThreeSubHeading}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    </div>
  </div>
)

export default Phone
